(() => {
  "use strict";

  const one = (selector, root = document) => root.querySelector(selector);
  const all = (selector, root = document) => [...root.querySelectorAll(selector)];
  const twoDigits = (value) => String(value + 1).padStart(2, "0");
  const worksNode = one("[data-cavellune-works]");
  const works = worksNode ? JSON.parse(worksNode.textContent) : [];

  const gallery = one("[data-art-grid]");
  const thumbnailRail = one("[data-thumbnail-rail]");
  const productStage = one(".product-stage");
  const productImage = one("[data-product-image]");
  const productIndex = one("[data-product-index]");
  const productCaption = one("[data-product-caption]");

  if (gallery && thumbnailRail) {
    works.forEach((work, index) => {
      const card = document.createElement("button");
      card.className = "art-card reveal";
      card.type = "button";
      card.setAttribute("aria-label", `Open full preview: ${work.title}`);
      card.innerHTML = `<img src="${work.src}" alt="${work.alt}" loading="lazy"><span class="preview-shield" aria-hidden="true"><b>CAVELLUNE</b><small>Preview · Edition 01</small></span><span class="art-card__meta"><span>${twoDigits(index)}</span><p>${work.title}</p></span>`;
      card.addEventListener("click", () => openLightbox(index));
      gallery.append(card);

      const thumb = document.createElement("button");
      thumb.type = "button";
      thumb.className = `thumbnail${index === 0 ? " is-active" : ""}`;
      thumb.setAttribute("aria-label", `Show ${work.title}`);
      thumb.innerHTML = `<img src="${work.src}" alt="" loading="lazy">`;
      thumb.addEventListener("click", () => switchProductImage(index));
      thumbnailRail.append(thumb);
    });
  }

  function switchProductImage(index) {
    if (!productStage || !productImage) return;
    const work = works[index];
    productStage.classList.add("is-switching");
    window.setTimeout(() => {
      productImage.src = work.src;
      productImage.alt = work.alt;
      productIndex.textContent = twoDigits(index);
      productCaption.textContent = work.title;
      all(".thumbnail", thumbnailRail).forEach((thumb, thumbIndex) => thumb.classList.toggle("is-active", thumbIndex === index));
      productStage.classList.remove("is-switching");
    }, 180);
  }

  const lightbox = one("[data-lightbox]");
  const lightboxImage = one("[data-lightbox-image]");
  const lightboxIndex = one("[data-lightbox-index]");
  const lightboxCaption = one("[data-lightbox-caption]");
  let activeWork = 0;

  function updateLightbox(index) {
    activeWork = (index + works.length) % works.length;
    const work = works[activeWork];
    lightboxImage.src = work.src;
    lightboxImage.alt = work.alt;
    lightboxIndex.textContent = twoDigits(activeWork);
    lightboxCaption.textContent = work.title;
  }
  function openLightbox(index) {
    if (!lightbox || !works.length) return;
    updateLightbox(index);
    lightbox.showModal();
    document.body.classList.add("is-locked");
  }
  function closeLightbox() {
    if (!lightbox) return;
    lightbox.close();
    document.body.classList.remove("is-locked");
  }
  all("[data-open-gallery]").forEach((button) => button.addEventListener("click", () => openLightbox(Number(button.dataset.openGallery) || 0)));
  one("[data-close-lightbox]")?.addEventListener("click", closeLightbox);
  one("[data-lightbox-prev]")?.addEventListener("click", () => updateLightbox(activeWork - 1));
  one("[data-lightbox-next]")?.addEventListener("click", () => updateLightbox(activeWork + 1));
  lightbox?.addEventListener("click", (event) => { if (event.target === lightbox) closeLightbox(); });
  lightbox?.addEventListener("close", () => document.body.classList.remove("is-locked"));
  document.addEventListener("keydown", (event) => {
    if (!lightbox?.open) return;
    if (event.key === "ArrowLeft") updateLightbox(activeWork - 1);
    if (event.key === "ArrowRight") updateLightbox(activeWork + 1);
  });

  const cartDrawer = one("[data-cart-drawer]");
  const drawerScrim = one("[data-drawer-scrim]");
  const cartCount = one("[data-cart-count]");
  const cartEmpty = one("[data-cart-empty]");
  const cartItems = one("[data-cart-items]");
  const cartSummary = one("[data-cart-summary]");
  const cartTotal = one("[data-cart-total]");

  function money(cents, currency = "EUR") {
    return new Intl.NumberFormat(document.documentElement.lang || "en", { style: "currency", currency }).format(cents / 100);
  }
  function escapeHtml(value) {
    return String(value).replace(/[&<>'"]/g, (character) => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", "'": "&#39;", '"': "&quot;" }[character]));
  }
  async function getCart() {
    const response = await fetch(`${window.Shopify?.routes?.root || "/"}cart.js`, { headers: { Accept: "application/json" } });
    if (!response.ok) throw new Error("Cart could not be loaded");
    return response.json();
  }
  function renderCart(cart) {
    const hasItems = cart.item_count > 0;
    cartCount.textContent = cart.item_count;
    cartEmpty.hidden = hasItems;
    cartSummary.hidden = !hasItems;
    cartTotal.textContent = money(cart.total_price, cart.currency || "EUR");
    cartItems.innerHTML = cart.items.map((item) => `
      <article class="cart-item">
        ${item.image ? `<img src="${item.image.replace(/(\.(?:jpg|jpeg|png|webp))(\?.*)?$/i, "_240x$1$2")}" alt="">` : ""}
        <div><p>${escapeHtml(item.product_title)}</p><span>${escapeHtml(item.variant_title || "Digital edition")}</span><button type="button" data-remove-key="${escapeHtml(item.key)}">Remove</button></div>
        <strong>${money(item.final_line_price, cart.currency || "EUR")}</strong>
      </article>`).join("");
  }
  async function refreshCart() {
    try { renderCart(await getCart()); } catch (error) { showToast("Cart connection interrupted"); }
  }
  function openCart() {
    drawerScrim.hidden = false;
    cartDrawer.classList.add("is-open");
    cartDrawer.setAttribute("aria-hidden", "false");
    document.body.classList.add("is-locked");
  }
  function closeCart() {
    cartDrawer.classList.remove("is-open");
    cartDrawer.setAttribute("aria-hidden", "true");
    document.body.classList.remove("is-locked");
    window.setTimeout(() => { drawerScrim.hidden = true; }, 520);
  }
  function showToast(message) {
    const toast = one("[data-toast]");
    toast.textContent = message;
    toast.classList.add("is-visible");
    window.clearTimeout(showToast.timeout);
    showToast.timeout = window.setTimeout(() => toast.classList.remove("is-visible"), 2600);
  }
  async function addVariant(id) {
    const response = await fetch(`${window.Shopify?.routes?.root || "/"}cart/add.js`, {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }] })
    });
    if (!response.ok) throw new Error("Item could not be added");
    await refreshCart();
    showToast("The Riviera Ledger was added");
    openCart();
  }

  all("[data-open-cart]").forEach((button) => button.addEventListener("click", () => { refreshCart(); openCart(); }));
  all("[data-close-cart]").forEach((button) => button.addEventListener("click", closeCart));
  drawerScrim?.addEventListener("click", closeCart);
  all("[data-product-form]").forEach((form) => form.addEventListener("submit", async (event) => {
    event.preventDefault();
    const submit = form.querySelector("button[type='submit']");
    const id = form.querySelector("[name='id']")?.value;
    submit.disabled = true;
    try { await addVariant(id); } catch (error) { showToast("Please try again"); }
    finally { submit.disabled = false; }
  }));
  all("[data-add-variant]").forEach((button) => button.addEventListener("click", async () => {
    button.disabled = true;
    try { await addVariant(button.dataset.variantId); } catch (error) { showToast("Please try again"); }
    finally { button.disabled = false; }
  }));
  cartItems?.addEventListener("click", async (event) => {
    const button = event.target.closest("[data-remove-key]");
    if (!button) return;
    button.disabled = true;
    await fetch(`${window.Shopify?.routes?.root || "/"}cart/change.js`, {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ id: button.dataset.removeKey, quantity: 0 })
    });
    await refreshCart();
    showToast("Edition removed from cart");
  });
  const consentBox = one("[data-digital-consent]");
  const consentCheckout = one("[data-consent-checkout]");
  const updateConsentCheckout = () => {
    if (!consentBox || !consentCheckout) return;
    const boxes = all("input[type='checkbox']", consentBox);
    consentCheckout.disabled = boxes.length !== 2 || boxes.some((box) => !box.checked);
  };
  consentBox?.addEventListener("change", updateConsentCheckout);
  updateConsentCheckout();

  const header = one("[data-header]");
  const onScroll = () => header?.classList.toggle("is-condensed", window.scrollY > 60);
  window.addEventListener("scroll", onScroll, { passive: true });
  onScroll();
  const observer = "IntersectionObserver" in window ? new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (!entry.isIntersecting) return;
      entry.target.classList.add("is-visible");
      observer.unobserve(entry.target);
    });
  }, { threshold: .12, rootMargin: "0px 0px -30px" }) : null;
  all(".reveal").forEach((element) => observer ? observer.observe(element) : element.classList.add("is-visible"));
  refreshCart();
})();
